import { Node_Type, Decoration_Type, FontSizeData_fontType } from 'ricos-schema';
import RicosDocumentStyle from './document-style/document-style.js';
import RicosTextualTheme from './textual-theme/textual-theme.js';
import { TextNodeTransformer } from './text-node-transformer.js';
import { parseDocStyle } from 'ricos-content/libs/convertDocStyleToDraft';
import './text-style-transformer.js';
import './utils-398956f3.js';
import 'ricos-content/libs/utils';
import './textual-theme/custom-styles.js';
import './textual-theme/empty-custom-style.js';
import './textual-theme/custom-style.js';
import './themeStrategy/generators/palette.js';
import './themeUtils-70529429.js';
import './themeStrategy/generators/identifiers.js';
import './themeStrategy/palettes/presets.js';
import './themeStrategy/palettes/wixPaletteUtils.js';
import 'lodash';
import './document-style/node-style.js';
import './document-style/text-style.js';
import './decorations/decorations.js';
import './decorations/bold-decoration.js';
import './decorations/empty-decoration.js';
import './decorations/color-decoration.js';
import './decorations/font-size-decoration.js';
import './decorations/italic-decoration.js';
import './decorations/underline-decoration.js';
import './document-style/text-node-style.js';
import './themeStrategy/themeStrategy.js';
import 'react';
import './themeStrategy/generators/typography.js';
import './themeStrategy/generators/customStyles.js';
import './themeStrategy/defaults.js';

const TOPICS = [
  "ricos.styles.functionality.themeUpdate",
  "ricos.styles.functionality.documentStyleUpdate"
];
class RicosStyles {
  constructor() {
    this.theme = new RicosTextualTheme({});
    this.documentStyle = new RicosDocumentStyle({});
    this.id = "ricos-styles";
    this.topicsToPublish = TOPICS;
    this.topicsToSubscribe = TOPICS;
    this.onThemeUpdate = (callback) => {
      var _a;
      return (_a = this.subscriptors) == null ? void 0 : _a.byTopic("ricos.styles.functionality.themeUpdate").subscribe(callback);
    };
    this.onDocumentStyleUpdate = (callback) => {
      var _a;
      return (_a = this.subscriptors) == null ? void 0 : _a.byTopic("ricos.styles.functionality.documentStyleUpdate").subscribe(callback);
    };
  }
  toStyleTags() {
    return [this.theme.toStyleTag(), this.documentStyle.toStyleTag()];
  }
  getDecoration(node, decorationType, editorElement) {
    if (![
      Node_Type.PARAGRAPH,
      Node_Type.HEADING,
      Node_Type.BLOCKQUOTE,
      Node_Type.CODE_BLOCK
    ].includes(node.type)) {
      return {};
    }
    if (editorElement && decorationType === Decoration_Type.FONT_SIZE) {
      const styles = window.getComputedStyle(editorElement);
      const fontSize = styles.getPropertyValue(
        `--ricos-custom-${propertyNameKeyFromNodeType(node)}-font-size`
      );
      return {
        type: Decoration_Type.FONT_SIZE,
        fontSizeData: {
          unit: FontSizeData_fontType.PX,
          value: parseInt(fontSize, 10)
        }
      };
    }
    const nodeType = new TextNodeTransformer(node).getDocumentStyleKey();
    const documentStyleDecoration = this.documentStyle.getDecoration(nodeType, decorationType);
    const themeDecoration = this.theme.getDecoration(nodeType, decorationType);
    return themeDecoration.overrideWith(documentStyleDecoration).getDecoration();
  }
  getTextStyle(node) {
    const nodeType = new TextNodeTransformer(node).getDocumentStyleKey();
    const documentStyleTextStyle = this.documentStyle.getTextStyle(nodeType);
    const themeTextStyle = this.theme.getTextStyle(nodeType);
    return themeTextStyle.overrideWith(documentStyleTextStyle.getTextStyle()).getTextStyle();
  }
  getNodeStyle(node) {
    const nodeType = new TextNodeTransformer(node).getDocumentStyleKey();
    const documentStyleNodeStyle = this.documentStyle.getNodeStyle(nodeType);
    const themeTextStyle = this.theme.getNodeStyle(nodeType);
    return themeTextStyle.overrideWith(documentStyleNodeStyle.getNodeStyle()).getNodeStyle();
  }
  getTheme() {
    return this.theme;
  }
  setTheme(theme) {
    var _a;
    this.theme = new RicosTextualTheme(theme);
    (_a = this.publishers) == null ? void 0 : _a.byTopic("ricos.styles.functionality.themeUpdate").publish(theme);
    return this;
  }
  getDocumentStyle() {
    return this.documentStyle;
  }
  setDocumentStyle(documentStyle) {
    var _a;
    this.documentStyle = new RicosDocumentStyle(documentStyle);
    (_a = this.publishers) == null ? void 0 : _a.byTopic("ricos.styles.functionality.documentStyleUpdate").publish(documentStyle);
    return this;
  }
  toDraftDocumentStyle() {
    return parseDocStyle(this.documentStyle.toContent());
  }
}
const propertyNameKeyFromNodeType = (node) => {
  switch (node.type) {
    case Node_Type.HEADING:
      return `h${node.headingData.level}`;
    case Node_Type.BLOCKQUOTE:
      return "quote";
    case Node_Type.CODE_BLOCK:
      return "code-block";
    default:
      return "p";
  }
};

export { RicosStyles };
//# sourceMappingURL=styles.js.map
